import TOGGLE_DRAWER from "../plugins/toggleDrawer"
import PAGETRANSITION from "../plugins/pagetransition"
import ANCHORLINK from "../plugins/anchorlink";
import CURRENT_NAV from "../plugins/currentNav";
import style from '../json/mapstyle.json'
import '../plugins/googlemap'
import OPENWINDOW from "../plugins/openwindow";


const [w,d,l] = [window,document,location]

export default function init () {
  
  d.documentElement.classList.remove('no-js')
  PAGETRANSITION()
  d.documentElement.classList.add('is-loading')
  w.addEventListener('load',()=> d.documentElement.classList.remove('is-loading'))
  w.addEventListener('load',ANCHORLINK)
  w.addEventListener('load',OPENWINDOW)

  CURRENT_NAV('[data-plugin="currentNav"]')
  
  TOGGLE_DRAWER()

  // ページトップをスクロール量で表示する
  $.scrollspy({
    trigger: (w.innerHeight * 0.5),
    onBefore(/* pos */) {
      $('.p-gotop__wrap').addClass('is-hidden');
    },
    onAfter() {
      $('.p-gotop__wrap').removeClass('is-hidden');
    }
  })

  // map init
  const map_keys = {
    'local':          'AIzaSyCTB3MSMYkTjSz6l30k79XflmmL_FcOxkg', //development
    'popy.yajimaya.co.jp': 'AIzaSyD1tNT7a5HjCvUUsQ9qiDtW1jqY9maV470' //production
  }
  $.getScript(`https://maps.googleapis.com/maps/api/js?key=${(map_keys[l.host]||map_keys['local'])}`)
  .done(() => {
    $('[data-plugin="googlemap"]').googlemap({
      styleObj:{
        name: 'mapstyle',
        style
      },
      markers:[
        {
          title: '谷島屋 浜松本店',
          latlng: '34.7041687,137.734452',
          address: '〒430-0926<br>静岡県浜松市中区砂山町６−１<br>８階 メイワン',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 イオンモール浜松志都呂店',
          latlng: '34.6971801,137.6493907',
          address: '〒432-8069<br>静岡県浜松市西区志都呂２丁目３７−１',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 サンストリート浜北店',
          latlng: '34.7960677,137.7614958',
          address: '〒434-0041<br>静岡県浜松市浜北区平口２８６１<br>サンストリート浜北 1階',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 連尺店',
          latlng: '34.7073728,137.7274366',
          address: '〒430-0939<br>静岡県浜松市中区連尺町３０９−１',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 三方原店',
          latlng: '34.779973,137.7173072',
          address: '〒433-8105<br>静岡県浜松市北区三方原町７５９−１',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店本沢合店',
          latlng: '34.8092591,137.8019433',
          address: '〒434-0014<br>静岡県浜松市浜北区本沢合１２３−２',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '聖隷浜松病院売店',
          latlng: '34.7304851,137.7250734',
          address: '〒430-8558<br>静岡県浜松市中区住吉２丁目１２−１２<br>聖隷浜松病院内',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 聖隷三方原病院売店',
          latlng: '34.7925231,137.6901892',
          address: '〒433-8105<br>静岡県浜松市北区三方原町３４５３<br>聖隷三方原病院内',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 医科大学売店',
          latlng: '34.7680313,137.7424625',
          address: '〒431-3125<br>静岡県浜松市東区半田山１丁目２０−１',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 ららぽーと磐田店',
          latlng: '34.7496871,137.8429488',
          address: '〒438-0801<br>静岡県磐田市高見丘１２００<br>1階 ららぽーと磐田',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店 アピタ磐田店',
          latlng: '34.718414,137.856402',
          address: '〒438-0071<br>静岡県磐田市今之浦３丁目１−１１<br>アピタ磐田1Ｆ',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        },
        {
          title: '谷島屋書店磐田店',
          latlng: '34.7217466,137.8465731',
          address: '〒438-0077<br>静岡県磐田市国府台５８−２',
          icon: '/assets/img/home/map_peg.png',
          iconSize: '40,52',
        }
      ]
    })
  })
}